import React from 'react';
import { Group, Rect, Circle } from 'react-konva';
import { WallItem as WallItemType, Position, Size } from '../../types';

interface WallItemProps {
  id: string;
  item: WallItemType;
  position: Position;
  size: Size;
  rotation: number;
  isSelected: boolean;
  onDragStart: (e: any) => void;
  onDragEnd: (e: any) => void;
  onClick: (e: any) => void;
  onRotate: (id: string, rotation: number) => void;
}

const WallItem: React.FC<WallItemProps> = ({
  id,
  position,
  size,
  rotation,
  isSelected,
  onDragStart,
  onDragEnd,
  onClick,
  onRotate,
  item
}) => {
  // Handle rotation with the rotation handle
  const handleRotateStart = (e: any) => {
    e.cancelBubble = true; // Prevent parent drag
  };
  
  const handleRotateMove = (e: any) => {
    e.cancelBubble = true; // Prevent parent drag
    
    // Calculate the center of the item
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();
    const groupPos = {
      x: position.x,
      y: position.y
    };
    
    // Calculate angle between center of item and current mouse position
    const angle = Math.atan2(
      pointerPos.y - groupPos.y,
      pointerPos.x - groupPos.x
    ) * 180 / Math.PI + 90;
    
    // Round to nearest 15 degrees for better usability
    const snappedAngle = Math.round(angle / 15) * 15;
    
    onRotate(id, snappedAngle);
  };

  return (
    <Group
      id={id}
      x={position.x}
      y={position.y}
      rotation={rotation}
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onClick={onClick}
    >
      <Rect
        id={id}
        width={size.width}
        height={size.height}
        fill="#999"
        stroke={isSelected ? "#3498db" : "#666"}
        strokeWidth={isSelected ? 2 : 1}
        x={-size.width / 2}
        y={-size.height / 2}
      />

      {/* Rotation Handle - only show when selected */}
      {isSelected && (
        <>
          {/* Rotation indicator line */}
          <Rect
            x={0}
            y={-size.height / 2 - 30}
            width={2}
            height={30}
            fill="#3498db"
            offsetX={1}
          />
          
          {/* Rotation handle */}
          <Circle
            x={0}
            y={-size.height / 2 - 40}
            radius={10}
            fill="#3498db"
            stroke="#fff"
            strokeWidth={2}
            draggable
            onDragStart={handleRotateStart}
            onDragMove={handleRotateMove}
            onMouseEnter={(e) => {
              const container = e.target.getStage()?.container();
              if (container) container.style.cursor = 'grab';
            }}
            onMouseLeave={(e) => {
              const container = e.target.getStage()?.container();
              if (container) container.style.cursor = 'default';
            }}
          />
        </>
      )}
    </Group>
  );
};

export default WallItem; 